<script>
export default {
  props: {
    color: {
      type: String,
      default: "#333333"
    }
  }
}
</script>

<template>
<svg :fill="color" width="36px" height="36px" viewBox="0 0 1000 1000" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  enable-background="new 0 0 1000 1000" xml:space="preserve">

<g>

<g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">

<path d="M100,4774.1c0-7.7,416-916.8,927-2018.4l924.5-2008.2l-256.8-1736c-143.8-955.3-267.1-1764.2-274.8-1797.6c-10.3-46.2-25.7-56.5-69.3-43.7c-30.8,7.7-138.7,23.1-238.8,30.8c-164.3,15.4-187.5,12.8-238.8-38.5c-61.6-61.6-71.9-197.7-20.5-269.6c41.1-56.5,105.3-69.3,793.5-172.1c523.9-77,562.4-79.6,624-38.5c79.6,51.4,105.3,148.9,64.2,244c-35.9,92.4-102.7,120.7-315.8,143.8c-95,10.3-179.8,28.3-187.5,41.1c-7.7,12.8,105.3,821.8,251.7,1797.6L2347,683.3L3705.4,2201C5277.1,3960,5313,4001.1,5302.7,4008.8c-7.7,10.3-187.5,35.9-2904.4,446.8C220.7,4781.8,100,4799.8,100,4774.1z M4072.7,3176.8c43.7-64.2,107.9,18-657.4-824.3c-272.2-303-513.6-554.7-534.2-562.4c-20.5-7.7-61.6,10.3-89.9,38.5c-51.4,48.8-51.4,56.5-12.8,115.6c43.7,69.3,1114.5,1253.2,1158.2,1281.4C3980.2,3256.4,4031.6,3238.4,4072.7,3176.8z"/>

<path d="M7298.1,3184.5c-1417.5-215.7-2580.8-395.5-2586-403.2c-5.1-5.1,654.8-755,1468.9-1666.6L7662.7-541.7l267.1-1779.6c143.8-978.4,259.4-1784.8,251.7-1792.5c-5.1-7.7-107.9-28.3-223.4-46.3c-166.9-25.7-226-46.2-262-92.4c-53.9-64.2-59.1-174.6-12.8-233.7c77-100.2,113-100.2,752.4-7.7c688.2,100.2,737,118.1,749.8,277.4c15.4,182.3-84.7,231.1-377.5,184.9c-205.4-33.4-208-33.4-220.8,20.6c-7.7,28.2-128.4,837.2-272.2,1795L8058.2-477.5l934.7,2028.7c516.2,1117.1,924.5,2028.7,906.5,2026.1C9884,3574.8,8713,3397.6,7298.1,3184.5z M6622.7,1407.5C7298.1,667.9,7275,693.6,7239,626.8c-66.8-123.3-125.8-77-721.6,580.4c-315.9,349.2-585.5,649.7-595.8,667.7c-10.3,20.5-7.7,59.1,7.7,87.3C5993.5,2080.3,6052.6,2031.5,6622.7,1407.5z"/>

</g>

</g>
</svg>
</template>